module.exports = __webpack_public_path__ + "static/media/oy_1.ea93e7b7.wav";